import React from 'react';
import { useStyles } from './_utility';
import { useStore } from '../../zustand';
import desktoprotate from '../../assets/icons/desktoprotate.svg';
import mousescroll from '../../assets/icons/mousescroll.svg';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const DesktopPrompt = () => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(true);
  const actions = useStore(state => state.actions);

  const handleClose = e => {
    setOpen(false)
    setTimeout(() => {
      actions.handleModalDisplay({ display: '', status: false });
    }, 750)
  };

  const handleQR = () => {
    handleClose()
    setTimeout(() => {
      actions.handleModalDisplay({ display: 'QRCodePrompt', status: true });
    }, 750)
  }

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="dispay-prompt"
      aria-describedby="dispay-prompt-modal"
      open={open}
      className={classes.root}
      TransitionComponent={Transition}
    >
      <section className={classes.modalClose}>
        <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </section>
      <section className={classes.modalTitle}>
        <h6>Helpful Viewing Hints for Desktop</h6>
      </section>
      <MuiDialogContent dividers className={classes.root}>
        <section className={classes.promptBody}>
          <div className={classes.promptTips}>
            <section className={classes.promptRow}>
            </section>
            <section className={classes.promptRow}>
              <section className={classes.promptIcon}>
                <img src={desktoprotate} alt="Double Tap Device" />
              </section>
              <section className={classes.promptCopy}>
                <h5>Rotate Image</h5>
                <p>Grab the object with your mouse and drag it</p>
              </section>
            </section>
            <section className={classes.promptRow}>
              <section className={classes.promptIcon}>
                <img src={mousescroll} alt="Adjust Scale" />
              </section>
              <section className={classes.promptCopy}>
                <h5>Adjust Scale</h5>
                <p>Use the mouse scroll wheel or use the scroll gesture on touch pads</p>
              </section>
            </section>
          </div>
        </section>
      </MuiDialogContent>
      <section className={classes.modalFooter}>
        <button onClick={handleQR}>View in your space</button>
        <button onClick={handleClose}>View in 3d</button>
      </section>
    </Dialog>
  );
}

export default DesktopPrompt;
